module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "图片证明"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('FileUploader', {
    attrs: {
      "uploadText": "图片证明",
      "fileList": _vm.formData.yanshou_pic,
      "limit": 1,
      "accept": ".zip,.rar",
      "name": 'yanshou_pic'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("建议打包上传一个压缩包文件")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "验收表扫描件"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.yanshoubiao_pic,
      "limit": 5,
      "name": 'yanshoubiao_pic'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left",
    on: {
      "click": _vm.download
    }
  }, [_vm._v("点击下载验收表")])], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-baeb5788","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubJiansheYanshou.vue
// module id = 2591
// module chunks = 0